import * as React from 'react'
import { DisplayContent } from 'react-content-engine'

export enum roomType {
  budget = 1,
  basic,
  comfort,
  premium,
}

export function getPlaceholder(value: roomType) {
  const options = {
    [roomType.budget]: 'Shared',
    [roomType.comfort]: 'Comfort',
    [roomType.basic]: 'Standard',
    [roomType.premium]: 'Premium',
  }
  return options[value] || 'Premium'
}

export function getRoomType(value: roomType) {
  return (
    <DisplayContent edit={true} contentKey={`roomType-${roomType[value]}`}>
      {getPlaceholder(value)}
    </DisplayContent>
  )
}

export function getRequestName(value: roomType) {
  const options = {
    [roomType.budget]: 'shared',
    [roomType.basic]: 'basic',
    [roomType.comfort]: 'comfort',
    [roomType.premium]: 'premium',
  }
  return options[value] || 'premium'
}
